import React from 'react';
import Helmet from 'react-helmet';

const SchoolPending = () => (
    <div className="container" style={{ padding: '80px 0' }}>
        <Helmet title="Account Rejected" />
        <div className="ui icon message">
            <i className="warning sign icon" />
            <div className="content">
                <div className="header">
                    Account pending
                </div>
                <p>
                    Sit tight! We’re currently verifying your details and you will receive a confirmation email when you can access the portal.
                </p>
            </div>
        </div>
    </div>
);

export default SchoolPending;



/** WEBPACK FOOTER **
 ** ./src/pages/SchoolPending.js
 **/